

<div style="margin-top: 100px;margin-bottom: 35px" class="container">
  <app-count-down [sessionExpirationTime]="sessionExpirationTime"></app-count-down>
</div>

<div class="details-cmd" >
  <div class="container">
    <header class="flexible">
      <h5 class="inline-block text-uppercase">{{'front_booking_payment.payment'| translate}}</h5>
      <a  title="Montrer/Cacher les détails" class="inline-block text-uppercase">
        <i class="fa fa-edit"></i>
      </a>
    </header>

    <div class="table-wrapper">
      <div class="width-100 table">
        <div  class="table-row flexible width-100">
          <div   class="flexible width-100">
            <div class="column flexible text-left col-md-5"><span style="padding-right: 10px;word-break: break-all;">{{ticket.pricing.label}}</span><span> {{'   '}}</span> <span class="opacity-50"><!--({{dayname}},  {{ day}} {{month}} à {{hours}}H)--><!--(Sun, 22 Jun 2014 at 08:45 AM)--></span></div>
            <div class="column flexible has-price"><span class="price ">{{functionUtils.getPricingPrice(ticket.pricing)+' '+functionUtils.getPricingDeviseSymbole(devise)}}</span></div>
            <div class="column flexible has-input flexible"><input type="number" disabled name="" value="{{1}}" class="text-left"></div>
            <div class="column flexible has-price" *ngIf="!ticket.pricing.open"><span class="price ">{{functionUtils.getPricingPrice(ticket.pricing) * 1 +' '+functionUtils.getPricingDeviseSymbole(devise)}}</span></div>
            <div class="column flexible has-price" *ngIf="ticket.pricing.open"><span class="price ">{{functionUtils.getPricingPrice(ticket.pricing)+' '+functionUtils.getPricingDeviseSymbole(devise)}}</span></div>
          </div>
        </div>

        <div style="margin-top: 50px">
          <div >

            <span >{{ticket.pricing.label}}</span>

            <ul  class="holders-list">
              <li  >{{'front_booking_payment.carrier_N_'| translate}} {{ 1 }}:  <span>{{ticket.firstname}} <b>{{ ticket.lastname}}</b></span></li>
            </ul>
          </div>
        </div>
        <!--    <div class="table-row flexible width-100">
              <div class="column flexible index text-center">02</div>
              <div class="flexible width-100">
                <div class="column flexible title text-left"><span>VIP Ticket</span> <span class="opacity-50">(Sun, 22 Jun 2014 at 08:45 AM)</span></div>
                <div class="column flexible has-price"><span class="price cur-euro"></span></div>
                <div class="column flexible has-input flexible"><input type="number" name="" disabled value="2" class="text-left"></div>
                <div class="column flexible has-price"><span class="price cur-euro">40</span></div>
              </div>
            </div>
            <ul class="holders-list">
              <li>Prénoms, <span>Nom</span></li>
              <li>Prénoms, <span>Nom</span></li>
            </ul>-->
        <div class="table-row flexible width-100 toto">
          <div class="flexible width-100 flexible-column">

            <div class="app-booking-item column flexible title text-right text-uppercase width-100">
              <span>sous total</span>
              <span class="price ">{{ticket.pricing.price | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
            </div>

            <div  class="app-booking-item column flexible title text-right text-uppercase width-100">
              <span>Réduction :{{' '+''}}</span>
              <span class="price ">{{ticket.reduction}}</span>
            </div>

            <div class="app-booking-item app-booking-item--price column flexible title text-right text-uppercase width-100">
              <span>{{'front_booking_payment.booking_fee'| translate}}</span>
              <span class="price ">{{(ticket.pricing.Totalprice - ticket.pricing.price) | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
            </div>


            <div class="app-booking-item column flexible title text-right text-uppercase width-100">
              <span>{{'front_booking_payment.final_total'| translate}}</span>
              <span class="price  text-green">{{ticket.pricing.Totalprice - ticket.reduction}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="details-cmd" id="credit-card">
  <div class="container" style="margin-bottom: 35px;">
    <!-- <iframe src="http://akces-app.devidia.net/payment/index.php" frameborder="0"></iframe> -->
    <!--   <div *ngIf="!event.is_free">
         <header class="flexible">
           <h5 class="inline-block text-uppercase">03. Paiement</h5>
         </header>
         <div class="table-wrapper">
           <div class="width-100 table">
             <div class="table-row flexible width-100">
               <div class="flexible width-100">
                 <div class="column flexible has-input flexible width-100" id="has-icon-as-placeholder">
                   <input type="text" name="" value="" placeholder="N° de carte" class="text-left"  [(ngModel)]="paiement.ncarte">
                   <i class="fa fa-credit-card opacity-50" id="as-placeholder"></i>
                 </div>
               </div>
             </div>
             <div class="table-row flexible width-100">
               <div class="flexible width-50">
                 <div class="column flexible has-input flexible width-100"><input type="text" name="" value="" placeholder="MM"  [(ngModel)]="paiement.mm" class="text-left"></div>
               </div>
               <div class="flexible width-50">
                 <div class="column flexible has-input flexible width-100"><input type="text" name=""  [(ngModel)]="paiement.aa" value="" placeholder="AA" class="text-left"></div>
               </div>
             </div>
             <div class="table-row flexible width-100">
               <div class="flexible width-50">
                 <div class="column flexible has-input flexible width-100"><input type="text" name="" value=""  [(ngModel)]="paiement.ccv" placeholder="CCV" class="text-left"></div>
               </div>
             </div>
           </div>
           <div class="addons-wrapper">
             <div class="addons-content flexible">
               <input type="checkbox" id="memorize" checked="">
               <label for="memorize">Mémoriser cette carte / Modifier mes coordonnées bancaires</label>
             </div>
             <label class="text-green text-uppercase" id="update-infos">
               <i class="fa fa-info"></i>
               Votre carte a été mis à jour
             </label>
           </div>
           <div class="addons-wrapper">
             <div class="addons-content flexible">
               <ul class="flexible width-100 rmp" id="paiements-methods">
                 <li><img src="assets/imgs/visa.png" alt="Visa"></li>
                 <li><img src="assets/imgs/mastercard.png" alt="MasterCard"></li>
                 <li><img src="assets/imgs/mastercard-secure.png" alt="MasterCard"></li>
                 <li><img src="assets/imgs/visa-verified.png" alt="Visa"></li>
               </ul>
             </div>
             <span class="text-center text-uppercase text-blue">paiement 100% sécurisé</span>
           </div>
           <div class="addons-wrapper">
             <div class="text-left">
               <a (click)="valider()" title="Valider mon paiement" class="btn inline-block btn-green">Valider mon paiement</a>
             </div>

             <div style="text-align: center;margin-top: 20px" *ngIf="onloading">
               <i class="fa fa-spinner" aria-hidden="true" ></i>
             </div>

             <div class="form-control-feedback alert-danger" *ngIf="!onloading && error" >
               <i class="fa fa-info-circle" aria-hidden="true"></i>une erreur s'est produite,vuiellez reéssayer</div>
           </div>
         </div>
       </div>-->
    <a (click)="retour()" title="Valider mon paiement" class="btn inline-block btn-green">{{'front_booking_payment.return'| translate}}</a>
    <a (click)="valider()" title="Valider mon paiement" class="btn inline-block btn-green">{{'front_booking_payment.validate'| translate}}</a>
  </div>
</div>
